var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13L6.5 9L7.5625 7.9375L9.75 10.125V3H11.25V10.125L13.4375 7.9375L14.5 9L10.5 13ZM5.99417 16C5.58139 16 5.22917 15.8531 4.9375 15.5594C4.64583 15.2656 4.5 14.9125 4.5 14.5V13H6V14.5H15V13H16.5V14.5C16.5 14.9125 16.3531 15.2656 16.0592 15.5594C15.7653 15.8531 15.4119 16 14.9992 16H5.99417Z",
    fill: "#06C270"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.74c2ae3d4c6d1a9136b24e83ea6c7e29.svg";
export { ForwardRef as ReactComponent };